import { Box, Typography } from "@mui/material"
import DashboardCards from "../components/Dashboard/DashboardCards"
import RecentActivities from "../components/Dashboard/RecentActivities"
import QuickActions from "../components/Dashboard/QuickActions"

const Dashboard = () => {
  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold", color: "#333" }}>
          Dashboard
        </Typography>
        <Typography variant="body1" color="text.secondary">
          View the overall status of your business
        </Typography>
      </Box>

      <DashboardCards />

      <Box sx={{ mt: 4, display: "grid", gridTemplateColumns: { xs: "1fr", lg: "1fr 1fr" }, gap: 3 }}>
        <RecentActivities />
        <QuickActions />
      </Box>
    </Box>
  )
}

export default Dashboard
